import React, { useEffect, useState } from 'react';
import { CatHeadline, CatTitle, IdResult, IdInfo, BtnDownload, BtnCreate, BtnIroning, BtnReset, InpSlider, InpCheckbox, BtnCoffee, ColLow, GroupBox, Cols, ColContainer, SingleRow, SingleRowSpaced, CatTopic, BtnUpload, InpRadioGroup, InpRadio } from '../components/component';
import { DefaultColors as Dflt, DefaultLink, DefaultMessage } from '../components/jptr-default.js';
import { InkCurves2 } from '../components/jptr-inkcurve.js';
import { CBH } from '../components/interpolate.js';
import { SwatchList } from '../components/swatch.js';
import { CloudStrike } from '../base/clrsplt-CloudConnect';

import { JiMinus, JiPlus } from '../components/jptr-icons';


const initBzrData = (lib, num) => {
    return Array.from({ length: num }, (_, i) => ({
        id: i,
        color: lib[i],
        point: CBH.defaultBeziers(100, 100)
    }));
};

export default function Cntntcrv() {

    const colorLib = Array.from({ length: 9 }, (_, i) => Dflt.getId(i));
    const [bzrData, setBzrData] = useState(() => initBzrData(colorLib, 4));

    const [linkId, setLinkId] = useState(DefaultLink.ID);
    const [linkInfo, setLinkInfo] = useState(DefaultLink.INFO);

    const [downloadable, setDownloadable] = useState(false);
    useEffect(() => {

        if (linkId === DefaultLink.ID || linkId === DefaultMessage.MESSAGE.calculating) {
            setDownloadable(false);
            setLinkInfo(DefaultLink.INFO);
            return;
        }
        setDownloadable(true);
    }, [linkId, setDownloadable, setLinkInfo]);

    const [limitLower, setLimitLower] = useState(0);
    const [limitUpper, setLimitUpper] = useState(100);

    const [currentSwatch, setCurrentSwatch] = useState(0);

    const [showOptions, setShowOptions] = useState(false);

    const handleInkCurvesReset = () => {
        setBzrData(initBzrData(colorLib, 4));
        setCurrentSwatch(0);
        setLimitLower(0);
        setLimitUpper(100);
        setLinkId(DefaultLink.ID);
    };

    const handleSliderChange = (value, indexToUpdate) => {
        const updatedPoints = bzrData[currentSwatch].point.map((point, index) => {
            if (index === indexToUpdate) {
                return { cpt: { x: point.cpt.x, y: 100 - value }, bpt: point.bpt };
            }
            return point;
        });
        handleBezierPointChange(updatedPoints);
        setLinkId(DefaultLink.ID);
    };

    const handleSwatchChange = (id) => {
        setCurrentSwatch(id);

        setLimitLower(100 - bzrData[id].point[0].cpt.y);
        setLimitUpper(100 - bzrData[id].point[1].cpt.y);
    };

    const handleSwatchAdd = () => {
        if (bzrData.length < colorLib.length) {
            setBzrData([...bzrData, {
                id: bzrData.length,
                color: colorLib[bzrData.length],
                point: CBH.defaultBeziers(100, 100)
            }]);
            setLinkId(DefaultLink.ID);
        }

    };

    const handleSwatchRemove = () => {
        if (bzrData.length > 1) {
            setBzrData(bzrData.slice(0, -1));
            setLinkId(DefaultLink.ID);
        }
    };

    function getBzrDataElement() {
        const id = (currentSwatch < bzrData.length) ? currentSwatch : 0;
        return bzrData[id];
    };

    const handleBezierPointChange = (points) => {
        setBzrData((prev) => {
            const newBzrData = [...prev];
            newBzrData[currentSwatch] = {
                ...newBzrData[currentSwatch],
                point: points
            };
            return newBzrData;
        });

        setLimitLower(100 - points[0].cpt.y);
        setLimitUpper(100 - points[1].cpt.y);

        setLinkId(DefaultLink.ID);
    };


    const handleShowOptions = () => {
        setShowOptions(!showOptions);
    }

    const handleFlat = () => {
        const ptsOld = bzrData[currentSwatch].point;
        const ptsNew = CBH.flattenBeziers(ptsOld[0].cpt, ptsOld[1].cpt);

        console.log(ptsNew);
        handleBezierPointChange(ptsNew);
    };


    const handleIroning = (value) => {

        const ptsOld = bzrData[currentSwatch].point;

        console.log(ptsOld);

        const cpt0 = { x: ptsOld[0].cpt.x, y: ptsOld[0].cpt.y };
        const cpt1 = { x: ptsOld[1].cpt.x, y: ptsOld[1].cpt.y };

        const length = value / 100;

        const ptsNew = CBH.easeBeziers(cpt0, cpt1, length);

        handleBezierPointChange(ptsNew);
    };


    const handleBtnCreateClick = () => {

        setLinkId(DefaultMessage.MESSAGE.calculating);

        const arrX = CBH.linearSteps(0, 100, 0.1);

        const arrY = bzrData.map(({ point }) => {
            const [pt0, pt1] = point.map(({ cpt, bpt }) => ({
                cpt: { x: cpt.x, y: 100 - cpt.y },
                bpt: { x: bpt.x, y: 100 - bpt.y }
            }));
            return arrX.map(x =>
                Math.round(CBH.interpolateBezier(x, pt0.cpt, pt0.bpt, pt1.bpt, pt1.cpt, 0.000001).y * 655.35)
            );
        });


        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                /* "colorset": "XXXX-XXXX-XXXX-XXXX", */
                "curves": arrY
            }),
            redirect: "follow"
        };

        const strike = new CloudStrike();
        strike.sendRequest('/link/curvelink', requestOptions)
            .then((data) => {
                setLinkId(data.body.fileID);
                setLinkInfo({
                    bytes: data.body.filesize,
                    channels: data.body.colormode,
                    duration: data.body.elapsed
                });

                localStorage.setItem("jptr-id-link", data.body.fileID);
            })
            .catch((error) => console.error(error));
    };

    const handleDownload = async () => {
        const strike = new CloudStrike();
        await strike.downloadLink(linkId, CloudStrike.LINK_TYPE.curveLink)
            .catch(error => { throw error; });
    };

    return (
        <div className="flx-2row-ana">

            <ColContainer>
                <ColLow>
                    <CatHeadline name="Curvelink" />
                    <p>
                        A curvelink can be used to adjust the channel with a bezier curve, e.g. for linearizations or the
                        retouch of a color shift / drift, that could be compensated by a gradation curve. A basic relinearization
                        could be another application. Each color / ink channel can be adjusted separately. The curve can be
                        saved and shared with others.
                    </p>
                </ColLow>

                <GroupBox style={{ maxWidth: '100%' }}>
                    <Cols>
                        <InpSlider name="Limit Lower" value={limitLower} onSliderChange={(value) => handleSliderChange(value, 0)} />
                        <InpSlider name="Limit Upper" value={limitUpper} onSliderChange={(value) => handleSliderChange(value, 1)} />
                        <InpCheckbox name="Show Advanced Options" checked={false} onChange={handleShowOptions} />
                    </Cols>
                    <BtnCreate onClick={handleBtnCreateClick} />
                </GroupBox>

                <Cols>
                    <IdResult linkId={linkId} />
                    <IdInfo {...linkInfo} />
                    <BtnDownload isDisabled={downloadable} onDownload={handleDownload} />
                </Cols>
            </ColContainer>

            <ColContainer>
                <Cols>
                    <InkCurves2
                        pts={getBzrDataElement().point}
                        curveColor={getBzrDataElement().color.rgb}
                        onBezierPointsChange={handleBezierPointChange}
                    />
                    <SingleRowSpaced>
                        <SingleRow>
                            <JiMinus className="ji-icon" onClick={handleSwatchRemove} />
                            <SwatchList key="swtchlst" colors={bzrData.map(data => data.color.rgb)} onSwatchChange={handleSwatchChange} />
                            <JiPlus className="ji-icon" onClick={handleSwatchAdd} />
                        </SingleRow>
                        <SingleRow>
                        <BtnIroning label='' isDisabled={true} onClick={handleFlat} />
                        <BtnReset onClick={handleInkCurvesReset} />
                        </SingleRow>
                    </SingleRowSpaced>
                </Cols>

                {showOptions && (
                    <GroupBox /* style={{ maxWidth: '100%' }} */>
                        <ColLow>
                            <CatTopic name="Advanced Options" />
                        </ColLow>
                        <ColLow>
                            <CatTitle name="Flattening" />
                            <SingleRow>
                                <p>Flattens a curve to a straight line.</p>
                                <BtnIroning label='' isDisabled={true} onClick={handleFlat} />
                            </SingleRow>
                        </ColLow>
                        <ColLow>
                            <CatTitle name="Easing" />
                            <p>Easing shapes the curve like an "S" or sigmoid.</p>
                            <InpSlider name="Easing" value={0} onSliderChange={(value) => handleIroning(value, 0)} />                            
                        </ColLow>
{/*                         <ColLow>
                            <CatTitle name="Measurement" />
                            <p style={{ color: 'var(--c3)' }}>Upload a Measurement file (CGATS) for a linearization.</p>
                            <InpRadioGroup name="Measurement" options={['CGATS']}>
                                <InpRadio name="CGATS" value="DeltaE 2000" />
                                <InpRadio name="CGATS" value="Chroma" />
                            </InpRadioGroup>
                            <SingleRow>
                                <BtnUpload label='Upload Measurements' isDisabled={true} />
                            </SingleRow>
                        </ColLow> */}
                    </GroupBox>
                )}
            </ColContainer>

        </div>
    );
}

// 102 lines old code